import { render, staticRenderFns } from "./CopyableItemWithTooltip.vue?vue&type=template&id=0b10aa00&"
import script from "./CopyableItemWithTooltip.vue?vue&type=script&setup=true&lang=js&"
export * from "./CopyableItemWithTooltip.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
